module.exports = __webpack_public_path__ + "static/media/flyer6.596efe04.jpg";